/* RAM Bikes — announcement bar paging. One message visible at a time; the
   chevrons rotate through the section's blocks. Nothing auto-advances. */
(function () {
  'use strict';
  var root = document.querySelector('[data-announcement]');
  if (!root) return;
  var items = Array.prototype.slice.call(root.querySelectorAll('.announce__text'));
  if (items.length < 2) return;
  var index = 0;
  function show(i) {
    index = (i + items.length) % items.length;
    items.forEach(function (el, n) { el.hidden = n !== index; });
  }
  var prev = root.querySelector('[data-announcement-prev]');
  var next = root.querySelector('[data-announcement-next]');
  if (prev) prev.addEventListener('click', function () { show(index - 1); });
  if (next) next.addEventListener('click', function () { show(index + 1); });
})();
